// extracted by mini-css-extract-plugin
export default {"cardImage":"cards-table_cardImage__cmR-x"};